module.exports = __webpack_public_path__ + "static/home_video-60412ec0915f726e591bc40340b80ce4.mp4";